import { useState, useContext, useEffect, useCallback } from "react";
import styles from "./styles.module.css";
import { PageValue } from "../../../contexts/page";

export default function Card({ workflow, onClick, selected = {} }) {
  const [block, setBlock] = useState(null);
  const tree = useContext(PageValue);
  const findBlock = useCallback((block, id) => {
    if (block.id === id) {
      setBlock({ name: block.name, id: block.id, component: block.component });
    }
    block.children.forEach((c) => {
      findBlock(c, id);
    });
  });

  useEffect(() => {
    if (workflow) {
      if (workflow.block) {
        findBlock(tree, workflow.block);
      }
      if (workflow.custom) {
        setBlock({ name: "reusable" });
      }
    }
  }, [workflow]);

  if (!block) {
    return null;
  }
  return (
    <div
      onClick={() => onClick(workflow)}
      className={
        selected && selected.id === workflow.id
          ? styles.card + " " + styles.active
          : styles.card
      }
    >
      <div className={styles.elementTitle}>{block.name}</div>
      <div className={styles.workflowTitle}>{workflow.name}</div>
    </div>
  );
}
